// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"2142fa9d","447":"3d4a1cea"}[chunkId] + ".chunk.js";
};